// app/ClientAnalytics.tsx
"use client";

import dynamic from "next/dynamic";

const isProd = process.env.NODE_ENV === "production";

// If not prod, use no-op components so nothing loads or renders.
const Analytics = isProd
  ? dynamic(() => import("@vercel/analytics/next").then((m) => m.Analytics), {
      ssr: false,
    })
  : () => null;

const SpeedInsights = isProd
  ? dynamic(() => import("@vercel/speed-insights/next").then((m) => m.SpeedInsights), {
      ssr: false,
    })
  : () => null;

export default function ClientAnalytics() {
  if (!isProd) return null;
  return (
    <>
      <Analytics />
      <SpeedInsights />
    </>
  );
}
